import {api} from "@/api/client";
import {User} from "@/api/types/User";
import {Reply} from "@/api/types/Reply";
import {Form} from "@/api/types/Form";
import List = Mocha.reporters.List;

type ListParams = {
    limit?: number,
    skip?: number,
    search?: string,
    formId?: number,
    sortBy?: string,
    sortDesc?: boolean,
    tenantId?: string
};

export type RepliesData = {
    answers: {question: string, answer: string}[],
    question: string[]
    score?: number,
}

export type ReplyLog = {
    id: number,
    tenantId: string,
    tenantName: string,
    userId: string,
    userName: string,
    action: string,
    questionName: string[],
    createdAt: Date,
    formId: number,
    formName: number
}

export type RepliesLogData = {
    limit: number,
    skip: number,
    total: number,
    data: ReplyLog[]
}


export const buildRepliesApi = (client = api) => ({
    async create(reply: Partial<Reply>) {
        const result = await client.post<Reply>('api/replies', reply)
        return result.data;
    },

    async fetch(id: number) {
        const result = await client.get<User>(`api/replies/${id}`)
        return result.data;
    },

    async list(limit?: number, skip?: number, formId?: number, sortBy?: string, sortDesc?: boolean, tenantId?: string) {
        const params: ListParams = {limit: limit, skip: skip, sortBy: sortBy, sortDesc: sortDesc, tenantId: tenantId}
        const result = await client.get<RepliesData[]>(`api/replies/byForm/${formId}`, { params })
        return result.data;
    },

    async patch(id: number, reply: Partial<Reply>) {
        const result = await client.patch<User>(`api/replies/${id}`, reply)
        return result.data;
    },

    async remove(id: number) {
        const result = await client.delete<User>(`api/replies/${id}`)
        return result.data;
    },

    async listLogs(limit?: number, skip?: number) {
        const params: ListParams = {limit: limit, skip: skip};
        const result = await client.get<RepliesLogData>('api/replies/logs', { params });
        return result.data;
    }

});

export const {
    create,
    fetch,
    list,
    patch,
    remove,
    listLogs
} = buildRepliesApi();